function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useProgressAnimation } from '../../../hooks/useProgressAnimation';
export function ProgressMask(props) {
  var _props$progress = props.progress,
      progress = _props$progress === void 0 ? 0 : _props$progress,
      _props$done = props.done,
      done = _props$done === void 0 ? false : _props$done;
  var progressCls = usePrefixCls('upload-progress-mask', {
    done: done
  });
  var progressInnerCls = usePrefixCls('upload-progress-mask-inner');
  var progressTextCls = usePrefixCls('upload-progress-text');

  var style = _objectSpread({
    height: "".concat(100 - progress, "%")
  }, useProgressAnimation(progress, false));

  return React.createElement("div", {
    className: progressCls
  }, React.createElement("div", {
    className: progressInnerCls,
    style: style
  }), React.createElement("span", {
    className: progressTextCls
  }, "".concat(progress, "%")));
}